import { render } from "./NotificationPreview.vue?vue&type=template&id=4da3e5c3"
import script from "./NotificationPreview.vue?vue&type=script&lang=js"
export * from "./NotificationPreview.vue?vue&type=script&lang=js"

import "./NotificationPreview.vue?vue&type=style&index=0&id=4da3e5c3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__